"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _svg = _interopRequireDefault(require("../../svg/svg"));

var _hooks = require("../../../hooks");

var _visuallyHidden = _interopRequireDefault(require("../../visually-hidden/visually-hidden"));

var _topNav = require("../shared/top-nav.styles");

var _navLinks = _interopRequireDefault(require("../shared/nav-links"));

var _mobileUserNavSection = _interopRequireDefault(require("./mobile-user-nav-section"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NavDropdown = (0, _styledComponents["default"])('div').withConfig({
  displayName: "mobile-nav__NavDropdown",
  componentId: "sc-1b42k5-0"
})(["position:absolute;top:100%;left:0;right:0;z-index:-1;background:", ";height:auto;max-height:", ";overflow:hidden;transition:max-height 0.25s ease-in-out;box-shadow:1px 10px 11px -8px rgb(0 31 35 / 15%);"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.isExpanded ? '100vh' : '0';
});
/* We might want to extract this to a reusable wrapper */

var TouchArea = (0, _styledComponents["default"])('div').withConfig({
  displayName: "mobile-nav__TouchArea",
  componentId: "sc-1b42k5-1"
})(["min-height:44px;min-width:44px;display:flex;justify-content:center;align-items:center;"]);

var MobileNav = function MobileNav(_ref) {
  var buttonSection = _ref.buttonSection,
      routes = _ref.routes,
      user = _ref.user,
      userFetchState = _ref.userFetchState;
  var primaryRoutes = routes.primaryRoutes,
      userRoutes = routes.userRoutes;
  var logoLink = primaryRoutes.find(function (route) {
    return route.logoLink === true;
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setExpanded = _useState2[1];

  var toggleMenu = function toggleMenu() {
    return setExpanded(function (prev) {
      return !prev;
    });
  };

  var closeMenu = (0, _react.useCallback)(function () {
    if (isExpanded) setExpanded(false);
  }, [isExpanded]);
  var ref = (0, _react.useRef)(null);
  (0, _hooks.useOutsideClick)(closeMenu, [], ref);
  return /*#__PURE__*/_react["default"].createElement(_topNav.Nav, {
    "aria-labelledby": "nav-mobile-label"
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden["default"], {
    id: "nav-mobile-label"
  }, "Main Menu"), /*#__PURE__*/_react["default"].createElement(_topNav.NavSection, null, /*#__PURE__*/_react["default"].createElement(TouchArea, {
    as: "a",
    href: logoLink === null || logoLink === void 0 ? void 0 : logoLink.url,
    tabIndex: "0" // for some reason, screen readers aren't picking up this anchor tag.
    ,
    "aria-label": "Home Link"
  }, /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    id: "glowforge-icon",
    height: "37px",
    width: null
  }))), /*#__PURE__*/_react["default"].createElement(_topNav.NavSection, null, buttonSection), /*#__PURE__*/_react["default"].createElement(_topNav.NavSection, null, /*#__PURE__*/_react["default"].createElement(TouchArea, {
    "aria-label": "Show Navbar Links",
    onClick: toggleMenu,
    role: "button",
    tabIndex: "0",
    "aria-controls": "mobile-nav-items"
  }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    className: "menuButton",
    id: "close",
    height: "30px",
    width: null
  }) : /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    className: "menuButton",
    id: "menu",
    height: "37px",
    width: null
  })), /*#__PURE__*/_react["default"].createElement(NavDropdown, {
    ref: ref,
    isExpanded: isExpanded
  }, /*#__PURE__*/_react["default"].createElement(_topNav.NavUL, {
    role: "list",
    "aria-hidden": !isExpanded,
    id: "mobile-nav-items"
  }, /*#__PURE__*/_react["default"].createElement(_navLinks["default"], {
    routes: primaryRoutes.filter(function (route) {
      return !route.logoLink;
    }),
    onMobile: true,
    keyboardNav: isExpanded
  }), /*#__PURE__*/_react["default"].createElement(_mobileUserNavSection["default"], {
    user: user,
    userFetchState: userFetchState,
    routes: userRoutes
  })))));
};

var _default = MobileNav;
exports["default"] = _default;